<template>
    <div>
        <h1>Alkohole</h1>
        <p>
            Alkohole sind Kohlenwasserstoffe die neben C- und H-Atomen auch noch
            eine
            <router-link to="/gruppen/hydroxyl"
                >Hydroxylgruppe(-OH)</router-link
            >
            besitzen. Auf natürliche Art und Weise entsteht Alkohol bei der
            anaeroben Gärung von Glukose, kann aber auch chemisch gewonnen
            werden. Bei seiner Verbrennung entsteht CO<sub>2</sub> und
            H<sub>2</sub>O. Aufgrund der OH-Gruppe sind Alkohole polar und
            deswegen auch hydrophil. Wie andere Kohlenwasserstoffe lassen sich
            Alkohole in einer homologen Reihe zählen, denn alle besitzen eine
            OH-Gruppe + Kohlenwasserstoffketten.
        </p>
        <hr class="chapter-split" />
        <chapter-heading title="Homologe Reihe"></chapter-heading>
        <div class="row">
            <table class="column left">
                <tr>
                    <th>1.</th>
                    <td>C<sub>1</sub>H<sub>3</sub>-OH</td>
                    <td>Methanol</td>
                </tr>
                <tr>
                    <th>2.</th>
                    <td>C<sub>2</sub>H<sub>5</sub>-OH</td>
                    <td>Ethanol</td>
                </tr>
                <tr>
                    <th>3.</th>
                    <td>C<sub>3</sub>H<sub>7</sub>-OH</td>
                    <td>Propanol</td>
                </tr>
                <tr>
                    <th>4.</th>
                    <td>C<sub>4</sub>H<sub>9</sub>-OH</td>
                    <td>Butanol</td>
                </tr>
                <tr>
                    <th>5.</th>
                    <td>C<sub>5</sub>H<sub>11</sub>-OH</td>
                    <td>Pentanol</td>
                </tr>
                <tr>
                    <th>6.</th>
                    <td>C<sub>6</sub>H<sub>13</sub>-OH</td>
                    <td>Hexanol</td>
                </tr>
                <tr>
                    <th>7.</th>
                    <td>C<sub>7</sub>H<sub>15</sub>-OH</td>
                    <td>Heptanol</td>
                </tr>
                <tr>
                    <th>8.</th>
                    <td>C<sub>8</sub>H<sub>17</sub>-OH</td>
                    <td>Octanol</td>
                </tr>
                <tr>
                    <th>9.</th>
                    <td>C<sub>9</sub>H<sub>19</sub>-OH</td>
                    <td>Nonanol</td>
                </tr>
                <tr>
                    <th>10.</th>
                    <td>C<sub>10</sub>H<sub>21</sub>-OH</td>
                    <td>Decanol</td>
                </tr>
                <tr>
                    <td>...</td>
                </tr>
            </table>

            <table class="column left">
                <tr>
                    <th>Allgemein:</th>
                    <td>C<sub>n</sub>H<sub>2n+1</sub>-OH</td>
                    <td><em>Alkan</em>-ol</td>
                </tr>
            </table>
        </div>
        <hr class="chapter-split" />
        <chapter-heading title="Drei Alkohol-Gruppen"></chapter-heading>
        <p>
            Die Unterteilung unterscheidet nach der Position der OH-Gruppe am
            Alkan.
        </p>
        <ul>
            <li>Primäre Alkohole</li>
            <li>Sekundäre Alkohole</li>
            <li>Tertiäre Alkohole</li>
        </ul>
        <img
            src="@/assets/img/stoffe/alkohole/1-2-3.jpg"
            alt="Drei Alkohol-Gruppen"
            title="Drei Alkohol-Gruppen"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Reaktionen mit Alkohol"></chapter-heading>
        <img
            src="@/assets/img/stoffe/alkohole/reaktionen.jpg"
            alt="Reaktionen mit Alkohol"
            title="Reaktionen mit Alkohol"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Zusammenfassung"></chapter-heading>
        <table>
            <tr>
                <th>Beschreibung</th>
                <td>
                    <ul>
                        <li>
                            bestehen nur aus C-Atomen und H-Atomen, sowie einer
                            <router-link to="/gruppen/hydroxyl"
                                >Hydroxylgruppe(-OH)</router-link
                            >
                        </li>
                        <li>besitzen ausschließlich Einfachbindungen</li>
                        <li>gestättigte, acyclische Kohlenwasserstoffe</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th>Allgemeine Summenformel</th>
                <td>C<sub>n</sub>H<sub>2n+1</sub>-OH</td>
            </tr>
            <tr>
                <th>Eigenschaften</th>
                <td>
                    <ul>
                        <li>gesättigt</li>
                        <li>hydrophil</li>
                        <li>lipophil (nimmt mit wachsender Kettenlänge zu)</li>
                        <li>brennbar</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th>Bindungen</th>
                <td>Einfachbindungen (Sigma-Bindungen)</td>
            </tr>
        </table>
    </div>
</template>
<script>
import ChapterHeading from '../../components/chapterHeading';
export default {
    components: { ChapterHeading },
};
</script>
